import React, { useEffect, useState, useRef } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import "./dashboard.css";

const HourlyBar = ({ data, heading }) => {
    const [formatData, setFormatData] = useState([]);
    const [time, setTime] = useState([]);
    const componentRef = useRef();
    useEffect(() => {
      data && setFormatData(Object.values(data?.data ?? data));
      data && setTime(Object.keys(data?.data ?? data));
    }, [data]);

    const headersList = data?.days || ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

    const getStyleForTable = (value) =>{

     if(heading === "Orders By Hours"){
      if(!value || value == 0){
       return "tablecolor5"
      }else if(value > 0 && value < 7){
        return "tablecolor1"
      }else if(value >= 7 && value < 13){
        return "tablecolor2"
      }else if(value >= 13 && value < 20){
        return "tablecolor3"
      }else{
        return "tablecolor4"
      }
     }else if(heading === "Sales By Hours"){
      if(!value || value == 0){
        return "tablecolor5"
      }else if(value > 0 && value < 5000){
        return "tablecolor1"
      }else if(value >= 5000 && value < 10000){
        return "tablecolor2"
      }else if(value >= 10000 && value < 20000){
        return "tablecolor3"
      }else {
        return "tablecolor4"
      }
     }
    }

    const getHourData = (hour) =>{
      const numericHour = Number(hour) || 0;
      if(heading === "Sales By Hours"){
       return hour ? numericHour.toFixed(2) : "0"
      }else{
       return hour ? hour : "0"
      }
    }

    const getHourlyReport= (e)=>{
      componentRef.current.handleDownload();
    }

    const totals = new Array(headersList.length).fill(0);
        
  return (
    <div className="col col-6 row mx-0 mt-3 px-2">
      <ReactHTMLTableToExcel
      id="test-table-xls-button"
      className="download-table-xls-button btn btn-success float-right mr-3 invisible"
      table={heading}
      filename={heading}
      sheet="sheet 1"
      buttonText="Sales Detail"
      ref={componentRef}
      />
    <div className="row px-0 mx-0 justify-content-between col col-12 ">
    <div className="dashboard__card col col-12 w-100 flex-basis-100">
     <div className="d-flex align-items-center justify-content-between">
      {heading ? <h5 className="mb-1 mt-0">{heading}</h5> : ""}
      <button
      className="btn btn-primary text-uppercase sm-text px-2 py-1 rounded"
      onClick={(e) => getHourlyReport(e)}
      >
      download report
      </button>
     </div>
     {
      heading === "Sales By Hours" ? (
        <div className="d-flex align-items-center mt-1 mb-2">
          <div className="d-flex align-items-center dashboard_table_head">
           0 <div className="mx-2 tablecolor5 tableColorDef"></div>
          </div>
          <div className="d-flex align-items-center dashboard_table_head">
           1-4999 <div className="mx-2 tablecolor1 tableColorDef"></div>
          </div>
          <div className="d-flex align-items-center dashboard_table_head">
           5000-9999 <div className="mx-2 tablecolor2 tableColorDef"></div>
          </div>
          <div className="d-flex align-items-center dashboard_table_head">
           10000-19999 <div className="mx-2 tablecolor3 tableColorDef"></div>
          </div>
          <div className="d-flex align-items-center dashboard_table_head">
            20000 & above<div className="mx-2 tablecolor4 tableColorDef"></div>
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center mt-1 mb-2">
          <div className="d-flex align-items-center dashboard_table_head">
           0 <div className="mx-2 tablecolor5 tableColorDef"></div>
          </div>
          <div className="d-flex align-items-center dashboard_table_head">
           1-6 <div className="mx-2 tablecolor1 tableColorDef"></div>
          </div>
          <div className="d-flex align-items-center dashboard_table_head">
           7-12 <div className="mx-2 tablecolor2 tableColorDef"></div>
          </div>
          <div className="d-flex align-items-center dashboard_table_head">
           13-20 <div className="mx-2 tablecolor3 tableColorDef"></div>
          </div>
          <div className="d-flex align-items-center dashboard_table_head">
           20 & above <div className="mx-2 tablecolor4 tableColorDef"></div>
          </div>
        </div>
      )
     }
     
    <div className="d-flex flex-col my-1 bill_modal_scroll scroll_always_show" style={{height:"calc(100vh - 9rem)"}}>
      <table id={heading} className="table sticky-table-header table-striped table-sm text-center">
        <thead className="bg-info text-white text-uppercase">
         <tr style={{background:"#0a8d6e"}}>
          <th scope="col" className="dashboard_table_head" style={{background: "inherit"}}>
          </th>
          {headersList.map((h, i) => (
            <th key={i} scope="col" className="dashboard_table_head text-preline" style={{background: "inherit", minWidth:"70px"}}>
              {h}
            </th>
          ))}
         </tr>
        </thead>
        <tbody>
          {
            data && formatData && formatData?.map((hourData,index)=>{
              hourData.forEach((val, i) => {
                if (totals[i] !== undefined) {
                  totals[i] += (Number(val) || 0);
                }
              });
              return(
                <tr key={index}>
                  <td className={`text-capitalized dashboard_table_body`}>
                   {time[index]}
                  </td>
                  {headersList.map((_, i) => (
                    <td key={i} className={`text-capitalized dashboard_table_body ${getStyleForTable(hourData[i])}`}>
                     {getHourData(hourData[i])}
                    </td>
                  ))}
                 </tr>
              )
            })
          }
           <tr>
             <td className="dashboard_table_head">Total</td>
             {totals.map((total, i) => (
               <td key={i} className="dashboard_table_head">{getHourData(total)}</td>
             ))}
           </tr>
         </tbody>
       </table>  
      </div> 
     </div>   
    </div>
  </div>
  )
}

export default HourlyBar
